import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalsComponent } from './views/modals/modals.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { DashboardComponent } from './views/dashboards/dashboard/dashboard.component';
import { LoginComponent } from './views/login/login/login.component'
import { AuthService as AuthGuard } from './services/auth.service';
import { ConfirmRegistrationComponent } from './views/login/confirm-registration/confirm-registration.component';
import { ConfirmPasswordResetComponent } from './views/login/confirm-password-reset/confirm-password-reset/confirm-password-reset.component';
import { PasswordResetComponent } from './views/login/password-reset/password-reset/password-reset.component';
import { TradeHistoryComponent } from './views/transactions/trade-history/trade-history.component';
import { SettingsComponent } from './views/account/settings/settings.component';
import { FiaComponent } from './views/fia/fia/fia.component';
import { LogoutComponent } from './views/login/logout/logout.component';

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64],
  };

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        data: { title: 'Login' }
    },
    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Login' }
    },
    {
        path: 'logout',
        component: LogoutComponent,
        data: { title: 'Logout' }
    },
    {
        path: 'resetpassword',
        component: PasswordResetComponent,
        data: { title: 'Reset Password' }
    },
    {
        path: 'login/resetpassword',
        component: PasswordResetComponent,
        data: { title: 'Reset Password' }
    },
    {
        path: 'resetpassword/confirm',
        component: ConfirmPasswordResetComponent,
        data: { title: 'Password Reset' }
    },
    {
        path: 'confirmations/register-confirm/:combinedKeys',
        component: ConfirmRegistrationComponent,
        data: { title: 'Confirm Registration' }
    },
    {
        path: 'confirmations/password-reset/:password-key',
        component: ConfirmPasswordResetComponent,
        data: { title: 'Password Reset' }
    },
    {
        path: 'dashboard', 
        component: DashboardComponent,
        data: { title: 'Dashboard' },
        canActivate: [AuthGuard]
    },
    {
        path: 'trade-history', 
        component: TradeHistoryComponent,
        data: { title: 'Trade History' },
        canActivate: [AuthGuard]
    },
    {
        path: 'fia', 
        component: FiaComponent,
        data: { title: 'FIA' },
        canActivate: [AuthGuard]
    },
    {
        path: 'settings', 
        component: SettingsComponent,
        data: { title: 'Settings' },
        canActivate: [AuthGuard]
    },
    { path: 'modals', component: ModalsComponent },
    { path: '**', component: NotFoundComponent }
];

@NgModule({
    imports: [CommonModule, RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
